import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "module-setup-card" }
const _hoisted_2 = { class: "module-setup-icon flex-center" }
const _hoisted_3 = { class: "module-setup-content" }
const _hoisted_4 = { class: "module-setup-title" }
const _hoisted_5 = { class: "module-setup-step" }
const _hoisted_6 = { class: "module-setup-progress" }
const _hoisted_7 = { class: "module-setup-meta" }
const _hoisted_8 = { class: "module-setup-percent" }
const _hoisted_9 = {
  key: 0,
  class: "module-setup-pill"
}
const _hoisted_10 = {
  key: 0,
  class: "module-setup-error"
}

import { computed } from "vue";

import { Button, RollingLoader } from "@/components/global";
import { CircleCloseIcon, SmileyCheck } from "@/components/svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'ModuleSetupNotice',
  props: {
    progress: { default: 0 },
    step: { default: null },
    status: { default: null },
    completionMessage: { default: null },
    usingPolling: { type: Boolean, default: false },
    error: { default: null },
    dismissible: { type: Boolean, default: false }
  },
  emits: ["dismiss"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const progressValue = computed(() => {
  const value = Number(props.progress ?? 0);
  return Math.min(100, Math.max(0, Number.isNaN(value) ? 0 : value));
});

const isCompleted = computed(() => {
  const normalizedStatus = (props.status ?? "").toLowerCase();
  return normalizedStatus === "succeeded" || progressValue.value >= 100;
});

const titleText = computed(() => isCompleted.value ? "Modules setup completed" : "Setting up modules");

const stepText = computed(() => {
  if (isCompleted.value) {
    return props.completionMessage ?? props.step ?? "Workspace setup completed successfully.";
  }

  return props.step ?? "Initializing Setup...";
});

const errorText = computed(() => {
  if (!props.error) return "";
  return String(props.error).trim();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.dismissible && isCompleted.value)
      ? (_openBlock(), _createBlock(_unref(Button), {
          key: 0,
          variant: "naked",
          class: "module-setup-dismiss",
          "aria-label": "dismiss-module-setup-notice",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('dismiss')))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(CircleCloseIcon))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (!isCompleted.value)
        ? (_openBlock(), _createBlock(_unref(RollingLoader), {
            key: 0,
            size: "lg",
            variant: "dark"
          }))
        : (_openBlock(), _createBlock(_unref(SmileyCheck), { key: 1 }))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h3", _hoisted_4, _toDisplayString(titleText.value), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(stepText.value), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", {
          class: "module-setup-progress-bar",
          style: _normalizeStyle({ width: `${progressValue.value}%` })
        }, null, 4)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(progressValue.value) + "%", 1),
        (__props.usingPolling)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Using fallback"))
          : _createCommentVNode("", true)
      ]),
      (!isCompleted.value && errorText.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(errorText.value), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})